import React from 'react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-10 px-4 sm:px-6 bg-brand-navy text-white border-t-4 border-brand-orange text-center" data-id="element-46">
      <p className="text-xs font-bold text-brand-orange uppercase tracking-widest mb-2" data-id="element-47">
        ONE LAST CHANCE
      </p>

      <p className="text-sm sm:text-base font-medium mb-6 leading-snug max-w-2xl mx-auto text-white/90" data-id="element-48">
        Your swimmers deserve more than improvised lessons.
        <br data-id="element-49" />
        <br data-id="element-50" />
        Stop spending hours planning every week. Stop second-guessing whether a
        drill is right for the students in front of you. Stop worrying about
        whether you're providing enough progression and structure.
        <br data-id="element-51" />
        <br data-id="element-52" />
        <span className="font-bold text-white" data-id="element-53">
          Give your swimmers the safe, engaging, and professional experience
          they deserve.
        </span>
      </p>

      <div className="bg-white/10 border border-white/20 rounded-lg p-4 mb-6 shadow-md max-w-sm mx-auto" data-id="element-54">
        <p className="text-xs sm:text-sm font-bold text-brand-pool mb-1 uppercase tracking-wide" data-id="element-55">
          Pack 6-in-1: SWIMMING COACH READY™ + 5 Premium Bonuses
        </p>
        <p className="text-base line-through text-white/60 mb-0.5" data-id="element-56">$97 USD</p>
        <p className="text-3xl font-heading font-black text-white leading-none" data-id="element-57">
          Only: $27 USD
        </p>
      </div>

      <a href={CHECKOUT_URL} className="block cursor-pointer mb-6" data-id="element-58">
        <img src="https://cdn.magicpatterns.com/uploads/aTXo3ByxQ5iocpXC8cAKKr/ChatGPT-Image-17-jun-2026_-06_41_45-p.m..webp" alt="Swimming Coach Ready 6-in-1 Box Set" className="w-full max-w-[220px] mx-auto object-contain drop-shadow-2xl" data-id="element-59" />
      </a>

      <div className="mb-4" data-id="element-60">
        <CTAButton data-id="element-61">🚀 YES, I WANT MY SWIMMING COACH READY™ PACK</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-[10px] sm:text-xs font-bold text-white/80" data-id="element-62">
        <div className="flex items-center gap-1.5" data-id="element-63">
          <Zap className="w-4 h-4 text-brand-orange" data-id="element-64" />
          <span data-id="element-65">Immediate Access — Delivered by Email</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-66">
          <Star className="w-4 h-4 fill-brand-orange text-brand-orange" data-id="element-67" />
          <span data-id="element-68">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-69">
          <Shield className="w-4 h-4 text-brand-pool" data-id="element-70" />
          <span data-id="element-71">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}